import React from 'react'
import './TranjectionTab.css'

const TranjectionTab = ({children}) => {
    return (
        <div className="tranjection-history">
            {children}
        </div>
    )
}

export default TranjectionTab
